// eslint-disable-next-line import-x/extensions -- bundled static JSON fixture requires the extension
import rawBestPractices from './best-practices.json';
import { BestPracticeFinding, BestPracticesData } from './scoring-engine-constants';

export const bp = rawBestPractices as BestPracticesData;

export const allFindings: BestPracticeFinding[] = [
  ...bp.categories.title.findings,
  ...bp.categories.bullets.findings,
  ...bp.categories.description.findings,
  ...bp.categories.alexa_for_shopping.findings
];

/**
 * The date to cite when telling a model (or the user) how current this guidance
 * is: the last hand-revision if there has been one, otherwise the research run.
 */
export const bpUpdatedOn: string = bp.metadata.last_revised ?? bp.metadata.run_date;

export const findingsBlock = (findings: BestPracticeFinding[]): string =>
  findings.map(f => `- [${f.confidence.toUpperCase()} CONFIDENCE] ${f.recommendation}`).join('\n');

export const deprecatedBlock = (): string =>
  bp.deprecated_practices.length > 0
    ? `\nDEPRECATED — do not use these practices:\n${bp.deprecated_practices
        .map(d => `- ${d.practice} → Use instead: ${d.replaced_by}`)
        .join('\n')}`
    : '';
